import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ForcePasswordChange from "@/components/ForcePasswordChange";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#121211] text-[#A1A19D]">
        <div className="cm-label animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePasswordChange />;
  return children;
}
